import { render, staticRenderFns } from "./TransfersComponent.vue?vue&type=template&id=cbdc5bd8"
import script from "./TransfersComponent.vue?vue&type=script&lang=js"
export * from "./TransfersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports